/* Haroutine homepage / 1.0.0. Safe for repeated sections and Shopify editor reloads. */
(() => {
  if (customElements.get('haroutine-home')) return;

  class HaroutineHome extends HTMLElement {
    connectedCallback() {
      // A section can be moved/reconnected by the theme editor.
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      const tablist = this.querySelector('[data-tabs]');
      if (tablist && this.tabs.length && this.panels.length) {
        tablist.hidden = this.tabs.length < 2;
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          const tab = this.tabs.find(item => item.dataset.tab === panel.dataset.panel);
          if (tab) panel.setAttribute('aria-labelledby', tab.id);
        });
        this.selectTab(this.activeTab || this.tabs[0].dataset.tab);
      }
      if (this.slides.length) {
        this.querySelector('[data-gallery]')?.setAttribute('aria-roledescription', 'carousel');
        const controls = this.querySelector('[data-gallery-controls]');
        if (controls) controls.hidden = this.slides.length < 2;
        this.selectSlide(this.slideIndex || 0);
      }
      this.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.matches('[data-tab]')) this.selectTab(target.dataset.tab);
        if (target.matches('[data-prev]')) this.selectSlide(this.slideIndex - 1);
        if (target.matches('[data-next]')) this.selectSlide(this.slideIndex + 1);
        if (target.matches('[data-dot]')) this.selectSlide(Number(target.dataset.dot));
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-tab]');
        if (!tab || !this.tabs.includes(tab)) return;
        const current = this.tabs.indexOf(tab);
        const rtl = getComputedStyle(this).direction === 'rtl';
        let index;
        if (event.key === 'ArrowRight') index = current + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') index = current + (rtl ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.tabs.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        const next = this.tabs[(index + this.tabs.length) % this.tabs.length];
        this.selectTab(next.dataset.tab);
        next.focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const detail = event.detail || {};
        if (detail.sectionId && String(detail.sectionId) !== this.dataset.sectionId) return;
        const block = Array.from(this.querySelectorAll('[data-block-id]')).find(el => el.dataset.blockId === String(detail.blockId));
        if (!block) return;
        const panel = block.closest('[data-panel]');
        if (panel && this.contains(panel)) this.selectTab(panel.dataset.panel);
        const slide = block.closest('[data-slide]');
        if (slide && this.contains(slide)) this.selectSlide(Number(slide.dataset.slide));
      }, options);
      this.setAttribute('data-enhanced', '');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    selectTab(key) {
      if (!this.tabs.some(tab => tab.dataset.tab === key)) key = this.tabs[0]?.dataset.tab;
      this.activeTab = key;
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== key;
        panel.tabIndex = panel.hidden ? -1 : 0;
      });
    }

    selectSlide(index) {
      const count = this.slides.length;
      if (!count) return;
      this.slideIndex = (index + count) % count;
      this.slides.forEach((slide, n) => {
        slide.hidden = n !== this.slideIndex;
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
      });
      this.dots.forEach((dot, n) => dot.setAttribute('aria-pressed', String(n === this.slideIndex)));
      const status = this.querySelector('[data-gallery-status]');
      if (status) status.textContent = `${status.dataset.exampleLabel} ${this.slideIndex + 1} ${status.dataset.ofLabel} ${count}`;
    }
  }
  customElements.define('haroutine-home', HaroutineHome);
})();
